import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { INFO_OVERLAY_BASE_CLASSNAME } from './Constants';
import { createInfoOverlay } from './InfoOverlay';
createComponents(".".concat(INFO_OVERLAY_BASE_CLASSNAME), createInfoOverlay, NO_PATTERN_BUSINESS_LOGIC);
